











































import Vue from "vue";

import { mapActions, mapGetters } from "vuex";
import { types } from "../store";
import { ApplicationState } from "../store/modules/application";

export default Vue.extend({
  name: "MyAccountPage",

  metaInfo() {
    return {
      title: "My Account | ARPA Small Business - Greene County, MO",
    };
  },

  methods: {
    ...mapActions({
      newApplicationVuex: types.NEW_APPLICATION,
      loadApplications: types.LIST_USER_APPLICATIONS,
    }),
    newApplication() {
      this.newApplicationVuex({ userId: this.user.id });
    },
  },

  computed: {
    ...mapGetters({
      loadingApplications: types.LOADING_APPLICATION,
      applications: types.APPLICATIONS_LIST,
      user: types.USER,
    }),
    listItems(): {
      id: number;
      organization: string;
      status: string;
      comments: string;
      submitted: boolean;
      lastComment: string;
    }[] {
      return this.applications.map((app: ApplicationState) => {
        const firstOnOccurence = app.comments.indexOf("On ") + 3;
        const lastComment =
          app.comments.length == 0
            ? "None"
            : app.comments.substring(
                firstOnOccurence,
                app.comments.indexOf("\r\n", firstOnOccurence) - 1
              );

        return {
          id: app.id,
          organization: app.businessName ? app.businessName : "Not Specified",
          status: app.status,
          comments: app.comments,
          lastComment,
          submitted: app.submitted,
        };
      });
    },
  },

  watch: {
    applications: {
      immediate: true,
      handler() {
        if (!this.loadingApplications) {
          this.loadApplications({ userId: this.user.id });
        }
      },
    },
  },
});
